/**
 * JobWorkspaceModal — the single job-workspace surface.
 *
 * The classic Metronic-styled workspace (with its legacy in-modal Gemini chat,
 * ChatArea/RightPanel/MobileWorkspace/MiddlePanel/WorkspaceHeader) was RETIRED
 * 2026-06. Every theme now renders the terminal-spirit TerminalJobWorkspaceModal,
 * whose per-job chat lives in the app-wide Andrei panel (opened via the
 * `[andrei]` button) rather than a bespoke in-modal LLM chat. See
 * project_agent_consolidation.
 *
 * This file stays as the public entry point — ~10 call sites import this default
 * export (EventLog, AttentionQueue, RecentClientActivity, ActiveCustomerList,
 * JobSummary, CustomerActivityPage, ClientDetailPanel, SelectedClientJobs,
 * EmailFeedContent) — so they don't all need updating. It wraps the modal in
 * InvoiceProvider so the modal's invoice actions work regardless of which screen
 * opened it. (ChatInputProvider is gone — only the retired in-modal chat used it.)
 */
import React from 'react';
import { JobWorkspaceModalProps } from './workspace/types';
import { InvoiceProvider } from '../invoices/contexts/InvoiceContext';
import TerminalJobWorkspaceModal from './workspace/TerminalJobWorkspaceModal';

const JobWorkspaceModal: React.FC<JobWorkspaceModalProps> = (props) => {
  return (
    <InvoiceProvider>
      <TerminalJobWorkspaceModal {...props} />
    </InvoiceProvider>
  );
};

export default JobWorkspaceModal;
